import React from 'react';
import { bool, object, string } from 'prop-types';
import appleTouchIcon from '../../static/apple-touch-icon.png';
import icon64 from '../../static/favicon-64x64.png';
import icon32 from '../../static/favicon-32x32.png';
import icon16 from '../../static/favicon-16x16.png';

import useFetchSites from '../hooks/data/useFetchSites';

const getMetaAlternateLinks = (sites, siteUrls, pathname, locale, noindex) => {
  if (noindex || !siteUrls || !siteUrls[pathname]) {
    return [];
  }

  const metaAlternateLinks = [];

  Object.entries(siteUrls[pathname]).forEach(([pageLocale, pageUrl]) => {
    const siteForLocale = sites.find(
      (site) => site.defaultLocale === pageLocale
    );

    if (!siteForLocale) {
      return;
    }

    const fullHref = `https://${siteForLocale.domain}${pageUrl}`;
    const pageLangCode = pageLocale.split('_')[0];
    const hreflang = pageLangCode === 'nb' ? 'no' : pageLangCode;

    metaAlternateLinks.push({
      hreflang,
      href: fullHref,
    });
  });

  return metaAlternateLinks;
};

export default function MetatagsForLayout({
  title,
  description,
  pathname,
  thumbnail = '/og-images/shareSocial-v.1.1.png',
  noindex = false,
  locale,
  siteUrls,
  canonicalUrl,
}) {
  const { sites } = useFetchSites();

  const foundSite = sites.find(
    (sitesSite) => sitesSite.defaultLocale === locale
  );

  if (locale === 'HUB') {
    console.log('HUB');
  } else if (!foundSite) {
    throw new Error('Locale or Site not found in MetatagsForLayout.jsx');
  }

  const metaAlternateLinks = getMetaAlternateLinks(
    sites,
    siteUrls,
    pathname,
    locale,
    noindex
  );

  let baseUrl = '';
  if (locale === 'HUB') {
    baseUrl = 'https://hub.businesswith.com';
  } else {
    baseUrl = `https://${foundSite.domain}`;
  }

  let localeToUse = locale;
  let language = localeToUse.split('_')[0];

  // Replace Norwegian Nynorsk with norwegian
  if (locale === 'nb_NO') {
    language = 'no';
    localeToUse = 'no_NO';
  }

  let image = '';
  if (thumbnail.includes('http')) {
    image = thumbnail;
  } else {
    image = `${baseUrl}${thumbnail}`;
  }

  return (
    <>
      <meta name="description" content={description || ''} />
      <meta property="og:description" content={description || ''} />
      <meta property="og:title" content={title} />
      <meta
        property="og:url"
        content={pathname ? baseUrl + pathname : baseUrl}
      />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="1200" />
      <meta property="og:locale" content={localeToUse} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={baseUrl} />
      <link rel="shortcut icon" type="image/x-icon" href="/favicon.ico" />
      {/* <link rel="shortcut icon" type="image/png" href={icon32} /> */}
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      <link rel="icon" type="image/png" sizes="64x64" href={icon64} />
      <link rel="icon" type="image/png" sizes="32x32" href={icon32} />
      <link rel="icon" type="image/png" sizes="16x16" href={icon16} />

      <link
        rel="canonical"
        href={
          canonicalUrl
            ? baseUrl + canonicalUrl
            : pathname
            ? baseUrl + pathname
            : baseUrl
        }
      />

      {metaAlternateLinks.map((alternateLink) => (
        <link
          key={alternateLink.hreflang}
          rel="alternate"
          hrefLang={alternateLink.hreflang}
          href={alternateLink.href}
        />
      ))}

      <title>{title}</title>
      <html lang={language} />
      {!!noindex && <meta name="robots" content="noindex" />}
    </>
  );
}

MetatagsForLayout.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  pathname: string.isRequired,
  thumbnail: string,
  noindex: bool,
  locale: string.isRequired,
  siteUrls: object,
};
